/**
 * The new client experience switch as a hook (cowork/clientFeatures.ts newClientExperienceOn): the same GET /v1/me the
 * staff state and the client pages read (shared cache key). `known` is false while /me loads, so a page can wait
 * instead of flashing one experience and then the other; a failed /me is known and off (fails closed to the older Omni).
 */
import { useQuery } from '@tanstack/react-query';
import { coworkApi } from '@/cowork/omniad/api/coworkApi';
import { newClientExperienceOn } from '@/cowork/clientFeatures';

export function useNewClientExperience(): { on: boolean; known: boolean } {
  const me = useQuery({ queryKey: ['cowork', 'me'], queryFn: () => coworkApi.staffScope.me(), staleTime: 5 * 60_000, retry: false });
  if (me.isPending) return { on: false, known: false };
  return { on: !me.isError && newClientExperienceOn(me.data), known: true };
}
